import styled from 'styled-components'
import { TitleMd } from '../../styles/text'

export const SobreTextarea = styled.textarea`
  height: 140px;
`

export const FormCard = styled.div`
  background-color: #fff;
  margin-top: 20px;
  border-radius: 8px;
  padding: 24px;
`

export const Label = styled(TitleMd)``
